import {
  Banknote,
  TrendingUp,
  Home,
  Car,
  Briefcase,
  Package,
  CreditCard,
  Landmark,
  TrendingDown,
  type LucideIcon,
} from 'lucide-react'
import type { NetWorthKind } from '@/types/db'

export interface NetWorthType {
  value: string
  label: string
  kind: NetWorthKind
  examples: string
  icon: LucideIcon
  color: string // classe Tailwind de cor (funciona em light/dark)
}

// Tipos selecionáveis (estilo Lunch Money). O `kind` deriva do tipo.
export const NET_WORTH_TYPES: NetWorthType[] = [
  // ---- Ativos ----
  { value: 'cash', label: 'Dinheiro', kind: 'asset', examples: 'espécie, conta não listada', icon: Banknote, color: 'text-emerald-500' },
  { value: 'investment', label: 'Investimentos', kind: 'asset', examples: 'ações, fundos, tesouro, cripto', icon: TrendingUp, color: 'text-green-500' },
  { value: 'real_estate', label: 'Imóveis', kind: 'asset', examples: 'casa, apartamento, terreno', icon: Home, color: 'text-blue-500' },
  { value: 'vehicle', label: 'Veículos', kind: 'asset', examples: 'carro, moto, caminhão', icon: Car, color: 'text-violet-500' },
  { value: 'employee_compensation', label: 'Remuneração', kind: 'asset', examples: 'RSU/ações da empresa, bônus a receber', icon: Briefcase, color: 'text-amber-500' },
  { value: 'other_asset', label: 'Outros bens', kind: 'asset', examples: 'joias, arte, equipamentos', icon: Package, color: 'text-cyan-500' },
  // ---- Passivos ----
  { value: 'credit_card', label: 'Cartão de crédito', kind: 'liability', examples: 'dívida de cartão externo', icon: CreditCard, color: 'text-rose-500' },
  { value: 'loan', label: 'Empréstimo / Financiamento', kind: 'liability', examples: 'imóvel, carro, pessoal, estudantil', icon: Landmark, color: 'text-orange-500' },
  { value: 'other_liability', label: 'Outras dívidas', kind: 'liability', examples: 'impostos a pagar, contas atrasadas', icon: TrendingDown, color: 'text-red-500' },
]

const byValue = new Map(NET_WORTH_TYPES.map((t) => [t.value, t]))

export function netWorthType(value: string | null | undefined): NetWorthType {
  return byValue.get(value ?? '') ?? NET_WORTH_TYPES[NET_WORTH_TYPES.length - 1]
}

export const NET_WORTH_ASSET_TYPES = NET_WORTH_TYPES.filter((t) => t.kind === 'asset')
export const NET_WORTH_LIABILITY_TYPES = NET_WORTH_TYPES.filter((t) => t.kind === 'liability')
